import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0 }) {
  const reduced = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-1">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduced ? false : { y: "110%", opacity: 0.4, filter: "blur(6px)" }}
            animate={{ y: "0%", opacity: 1, filter: "blur(0px)" }}
            transition={{ duration: 0.9, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function SectionHead({ overline, title, sub, center = false, testid }) {
  return (
    <div className={`mb-12 ${center ? "text-center" : ""}`} data-testid={testid}>
      {overline && (
        <Reveal y={12}>
          <p className="font-mono-lux text-[11px] uppercase tracking-[0.3em] text-[#7E1E3F] mb-4">{overline}</p>
        </Reveal>
      )}
      <Reveal delay={0.08}>
        <h2 className="font-serif-lux text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2E1A22] text-balance">{title}</h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className="mt-4 text-sm sm:text-base text-[#857078] max-w-xl leading-relaxed ${center ? 'mx-auto' : ''}">{sub}</p>
        </Reveal>
      )}
    </div>
  );
}

export function Marquee({ items }) {
  const list = items && items.length ? items : ["ROYAL HERITAGE", "TIMELESS MOMENTS", "GOLD FOIL PACKAGING", "ARTISAN DRY FRUITS", "HAND-FINISHED DETAILING", "THE SAVYRON STANDARD"];
  const row = [...list, ...list];
  return (
    <div className="relative py-6 border-y border-[#7E1E3F]/15 overflow-hidden" data-testid="editorial-marquee-ribbon">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((t, i) => (
          <span key={i} className="font-mono-lux text-xs tracking-[0.35em] text-[#857078] px-8 flex items-center gap-8">
            {t} <span className="text-[#7E1E3F]/60">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
